import { createContext, useContext } from 'react';
import type { User } from '../services/auth.api';

interface AuthContextType {
  user: User | null;
  isAuthenticated: boolean;
  isLoading: boolean;
  login: (username: string, password: string) => Promise<{ success: boolean; error?: string }>;
  logout: () => void;
  can: (permission: string) => boolean;
  refreshUser: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function useAuth() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
}

const allowAll = () => true;
/** For leaf components: works without a provider (component tests render them bare). */
export function useCan(): (permission: string) => boolean {
  return useContext(AuthContext)?.can ?? allowAll;
}
